const DashboardWrapper = ({ children }) => {
    return (
        <div className="main-content__dashboard">
            <div className="grid">
                <div className="grid-sizer"></div>
                {children}
            </div>
        </div>
    );
};

export default DashboardWrapper;
